/** Pointer → frame-fraction maths. Fractions (0..1) survive any player size. */

export interface Fraction {
  x: number;
  y: number;
}

function clamp01(v: number): number {
  if (Number.isNaN(v)) return 0;
  return Math.min(1, Math.max(0, v));
}

/**
 * Convert a client-space pointer position into 0..1 fractions of `rect`
 * (the canvas' bounding rect *at event time*). Positions outside the rect
 * clamp to its edge so a stroke that leaves the canvas stays valid.
 */
export function toFraction(clientX: number, clientY: number, rect: DOMRect): Fraction {
  if (rect.width <= 0 || rect.height <= 0) return { x: 0, y: 0 };
  return {
    x: clamp01((clientX - rect.left) / rect.width),
    y: clamp01((clientY - rect.top) / rect.height),
  };
}

/**
 * Evenly sample `points` down to at most `max`, always keeping the first
 * and last so the stroke's endpoints survive.
 */
export function decimate<T>(points: T[], max: number): T[] {
  if (max < 2 || points.length <= max) return points;
  const lastIndex = points.length - 1;
  const step = lastIndex / (max - 1);
  const out: T[] = [];
  for (let i = 0; i < max; i += 1) {
    out.push(points[Math.round(i * step)] as T);
  }
  return out;
}
